import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DettaglioProdotto} from "../../Progetti/Models/dettaglio-prodotto";
import {Tag} from "../../Progetti/Models/tag";
import {ToastrService} from "ngx-toastr";
import {ApiRestService} from "../../Progetti/_services/api-rest.service";
import {ApiPathsService} from "../../api-paths.service";

@Component({
  selector: 'app-product-highlights',
  templateUrl: './product-highlights.component.html'
})
export class ProductHighlightsComponent implements OnInit {
  @Input() id_prodotto: number;
  @Output() id_prodottoChange = new EventEmitter<number>();
  @Input() viewMode: 'detail'|'edit' = 'detail';
  @Input() dettagli: DettaglioProdotto[];
  @Output() dettagliChange = new EventEmitter<DettaglioProdotto[]>();
  @Output() Refresh = new EventEmitter();
  constructor(
    private toastService: ToastrService,
    private ApiRestService: ApiRestService,
    public apiPaths: ApiPathsService,
  ) { }

  ngOnInit(): void {
  }
  ItemsChanged(){
    this.dettagliChange.emit(this.dettagli);
  }
  edit(item: DettaglioProdotto) {
    if(item.modifica){
      if (item.id){
        item.id_prodotto = this.id_prodotto;
        item.modifica = !item.modifica;
        this.ApiRestService.UpdateDettaglio(item).subscribe((data) => {
          this.Refresh.emit();
        },error => {
          item.modifica = !item.modifica;
        });
      }else if(item.nome && item.descrizione && (item.immagine || item.id_immagine)){
        item.modifica = !item.modifica;
        item.id_prodotto = this.id_prodotto;
        this.ApiRestService.AddDettaglio(item).subscribe((data) => {
          this.Refresh.emit();
        },error => {
          item.modifica = !item.modifica;
        });
      }
      else
        this.toastService.warning("inserire i campi richiesti", "Attenzione!!");
    }else {
      item.modifica = !item.modifica;
    }
  }

  delete(value: DettaglioProdotto){
    if(value && value.modifica)
      this.Refresh.emit();
    else if(value && value.id){
      if (confirm("Sicuro di voler eliminare questo elemento dalla lista?")) {
        this.ApiRestService.DeleteDettaglio(value).subscribe(() => this.Refresh.emit());
      }
    }
    else if(value) {
      var indx = this.dettagli.findIndex(x => x === value)
      this.dettagli.splice(indx,1);
    }
  }
  add() {
    let tobeadded: DettaglioProdotto = new DettaglioProdotto();
    tobeadded.modifica = true;
    var out: DettaglioProdotto[] = [tobeadded]
    this.dettagli = out.concat(this.dettagli);
  }
  async schedacambiata(event, item: DettaglioProdotto) {
    const file: Blob = event.target.files[0];
    if (!file.type.includes("image")){
      this.toastService.warning("Questo formato non è supportato. Inserire solo immagini.", "Attenzione!")
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result.toString().length > 1){
        item.immagine = reader.result.toString();
        item.file = event.target.files[0].name;
      }
      else
        item.immagine = undefined;
    };
  }
}
